import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import Panel from '../UI/Panel';
import {
  GoogleTagManager,
  redirectToExternalPage as redirect,
} from '../../helpers';
import {
  ButtonIconStyled as ButtonIcon,
  ButtonTitleStyled as ButtonTitle,
  ChannelButtonStyled as ChannelButton,
  ChannelNavStyled as ChannelNav,
  ContentHeaderStyled as ContentHeader,
  NavTitleStyled as NavTitle,
  PanelContentStyled as PanelContent,
  SwitchButtonStyled as SwitchButton,
} from './styles/ChannelSwitchStyled';
import { SwitchIcon } from '../../images/nav';
import { BamIcon, FiberIcon, StoreIcon } from '../../images/channel-switch';

const channels = [
  {
    title: 'Internet Fibra',
    icon: FiberIcon,
    url: `${process.env.FIBER_CHANNEL_URL}/?utm_source=miwom&utm_medium=cambio_miwom&utm_id=cambio_fibra`,
  },
  {
    title: 'Internet Móvil',
    icon: BamIcon,
    url:
      'https://store.wom.cl/internet-movil/planes-modem-wifi-portatil/?utm_source=miwom&utm_medium=BAM_MIWOM&utm_id=BAM_MIWOM',
  },
  {
    title: 'Store WOM',
    icon: StoreIcon,
    url:
      'https://store.wom.cl/?utm_source=miwom&utm_medium=cambio_store&utm_id=cambio_store',
  },
];

const Activator = ({ setShow }) => (
  <SwitchButton
    type="button"
    aria-label="Cambiar servicio"
    onClick={() => {
      GoogleTagManager.tagInteractiveEvent({
        eventCategory: 'Home',
        eventAction: 'Cambio de Servicio',
        eventTag: 'Switch',
      });
      setShow(true);
    }}
  >
    <SwitchIcon />
    <ButtonTitle>Cambiar servicio</ButtonTitle>
  </SwitchButton>
);
Activator.propTypes = { setShow: PropTypes.func.isRequired };

const ChannelSwitch = () => {
  const isMobileDevice = useMediaQuery({
    query: '(max-device-width: 768px)',
  });

  const handleChannelSwitch = (title, url) => {
    GoogleTagManager.tagInteractiveEvent({
      eventCategory: 'Panel de Cambio',
      eventAction: 'Cambio de Servicio',
      eventTag: title,
    });

    redirect(url);
  };

  return (
    <Panel
      title="Servicios WOM"
      isMobileDevice={isMobileDevice}
      maxWidth="360px"
      activator={Activator}
      bodyColor="white"
    >
      <PanelContent>
        <ContentHeader>
          <span>Estás navegando en:</span>
          <strong>Telefonía móvil</strong>
        </ContentHeader>
        <ChannelNav>
          <NavTitle>¿A qué servicio quieres ingresar?</NavTitle>
          {channels.map(({ title, icon, url }) => (
            <ChannelButton
              key={title}
              onClick={() => handleChannelSwitch(title, url)}
            >
              <ButtonIcon as={icon} />
              {title}
            </ChannelButton>
          ))}
        </ChannelNav>
      </PanelContent>
    </Panel>
  );
};

export default ChannelSwitch;
